export const TEMPLATE_CATEGORY = [
    "template-category-pre",
    "template-category-post",
];

export const TEMPLATE_SUPER = [
    "template-super-pre",
    "template-super-post",
];

export const TEMPLATE_EMBEDDED_SUPER = [
    "template-esuper-pre",
    "template-esuper-post",
];

export const TEMPLATE_DYNAMIC = [
    "template-dynamic-pre",
    "template-dynamic-post",
];